import * as React from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import LinearProgress from '@material-ui/core/LinearProgress';
import Tooltip from '@material-ui/core/Tooltip';

import "./ProductBlacklist.scss";

// tslint:disable-next-line:no-empty-interface
export interface ITableProductBlacklistPros {
    categories: any[],
    error: string | null,
    loading: boolean,
    rows?: any[],
    delete(row:any): void,
}

// tslint:disable-next-line:no-empty-interface
export interface ITableProductBlacklist {
    count: number,
    limit: number,
    offset: number,
    page: number,
}

export class TableProductBlacklist extends React.Component<ITableProductBlacklistPros, ITableProductBlacklist> {

    constructor(props: ITableProductBlacklistPros) {
        super(props);
        this.state = {
            count: 1000,
            limit: 10,
            offset: 0,
            page: 0,
        }

        this.handleChangePage = this.handleChangePage.bind(this);
    }

    public render() {
        return (
            <div>
                {this.props.loading ? <LinearProgress /> : 
                    <div>    
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>SKU</TableCell>
                                    <TableCell>Data Inclusão</TableCell>
                                    <TableCell>Ação</TableCell>
                                </TableRow>
                            </TableHead>
                            {(!this.props.error && this.props.rows && this.props.rows.length > 0) &&  <TableBody>
                                {
                                    this.paginacaoVirtual(this.props.rows).map((row: any, key: number) => {
                                        return (
                                            <TableRow key={key}>
                                                <TableCell>{row.sku}</TableCell>
                                                <TableCell>{row.createdat}</TableCell>
                                                <TableCell>
                                                    <Tooltip title="Deletar">
                                                        <IconButton className="deleteAction"  onClick={this.deleteItem.bind(this, row)} aria-label="Deletar">
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })
                                }
                        </TableBody>
                        }
                        </Table>
                        <TablePagination
                            component="div"
                            page={this.state.page}
                            count={this.props.rows ? this.props.rows.length : this.state.count}
                            rowsPerPage={this.state.limit}
                            rowsPerPageOptions={[]}
                            backIconButtonProps={{
                                'aria-label': 'Previous Page',
                            }}
                            nextIconButtonProps={{
                                'aria-label': 'Next Page',
                            }}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={undefined}
                        />
                    </div>
                }
            </div>
        );
    }

    public deleteItem (row : any) {
        this.props.delete(row);
    };

    /**
     * Pagination
     * 
     * Methods add pagination to the result table
     * 
     */
    private paginacaoVirtual = (bookstoreAnalysisData: any[]) => {
        const start = this.state.offset;
        const end = start + this.state.limit;
        return bookstoreAnalysisData.slice(start, end)
    }

    private handleChangePage(ev: any, pageParam: number) {
        if (pageParam <= this.state.page) {
            this.setState({
                offset: pageParam * this.state.limit <= 0 ? 0 : pageParam * this.state.limit,
                page: pageParam,
            });
        } else {
            this.setState({
                offset: pageParam * this.state.limit,
                page: pageParam,
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/component/administration/registers/product-blacklist/TableProductBlacklist.tsx